import { colors } from './colors';
import localFont from 'next/font/local';
import { NextFont } from 'next/dist/compiled/@next/font';
import { TypographyTheme } from '@zopauk/react-components/types/components/styles/Theme';

const font = localFont({
  src: [
    {
      path: '../fonts/GillSansJL/GillSansNovaforJLVar.woff2',
      weight: '200 700',
    },
  ],
});

export const typography: TypographyTheme<NextFont> = {
  heading: {
    // CHECK IF USED
    sizes: {
      display: '68px',
      h1: '48px',
      h2: '32px',
      h3: '24px',
      h4: '20px',
      h5: '18px',
      h6: '16px',
    },
    // @ts-expect-error TODO: add this to zrc
    color: colors.jlMoneyGreenDark,
  },
  lineHeight: {
    display: '76px',
    small: '20px',
    lead: '28px',
    body: '22px',
    h1: '48px',
    h2: '36px',
    h3: '28px',
    h4: '28px',
    h5: '22px',
    h6: '22px',
  },
  letterSpacingMap: {
    display: '-2.86px',
    button: '-0.01px',
    text: '0',
    h1: '0',
    h2: '0',
    h3: '0',
    h4: '0',
    h5: '0',
    h6: '0',
  },
  text: {
    sizes: {
      small: '14px',
      lead: '20px',
      body: '16px',
    },
    color: colors.jlMoneyGreenDark,
  },
  weights: {
    extraBold: 600,
    semiBold: 600,
    regular: 400,
    medium: 500,
    bold: 600,
  },
  primary: `"GillSansJL", Calibri, sans-serif`,
  font,
};
